// extracted by mini-css-extract-plugin
export var actions = "_1r-0";
export var actionsContainer = "_1r-7";
export var border = "_1r-1";
export var childFullHeight = "_1r-f";
export var collapse = "_1r-2";
export var content = "_1r-a";
export var contentChild = "_1r-e";
export var fullscreen = "_1r-c";
export var hasLeftRadius = "_1r-k";
export var headerContainer = "_1r-3";
export var headerRow = "_1r-5";
export var hidePadding = "_1r-b";
export var navCollapsedGap = "_1r-l";
export var noScrollX = "_1r-m";
export var noScrollY = "_1r-n";
export var noTopPadding = "_1r-i";
export var optOutTopPadding = "_1r-d";
export var pageMain = "_1r-j";
export var pageOuter = "_1r-g";
export var pagePadding = "_1r-8";
export var pageScroll = "_1r-9";
export var profile = "_1r-o";
export var profileContainer = "_1r-p";
export var profileImage = "_1r-q";
export var profileMain = "_1r-r";
export var profileSubtitle = "_1r-t";
export var profileTitle = "_1r-s";
export var showLeftPadding = "_1r-h";
export var tabsPortalSlot = "_1r-6";
export var tabsWrapper = "_1r-4";
export var title = "_1r-u";